import { Component, Prop, Vue } from 'nuxt-property-decorator';

import IconStar from './../../assets/svg/star.svg';
import IconChevronDown from './../../assets/svg/chevron-down.svg';
import IconPhone from './../../assets/svg/phone.svg';
import IconEmail from './../../assets/svg/at-sign.svg';
import IconEdit from './../../assets/svg/edit-2.svg';
import IconMessage from './../../assets/svg/message-circle.svg';
import Button from '../button/index.vue';
// @ts-ignore
import { directive } from 'v-click-outside-x';

@Component<User>({
  components: {
    IconStar,
    IconChevronDown,
    IconPhone,
    IconEmail,
    IconEdit,
    IconMessage,
    Button
  },
  directives: {
    clickOutside: directive
  }
})
export default class User extends Vue {
  @Prop({ type: String, default: 'header' })
  type!: string;

  @Prop({ type: String, default: '' })
  title!: string;

  @Prop({ type: Array, default: ()=> new Array() })
  phoneList!: Array<string>;

  @Prop()
  user!: {
    id: string;
    firstname: string;
    lastname: string;
    job: string;
    phone: string;
    email: string;
    rating: number;
    image: string;
  };

  iconPhone: any = IconPhone;
  isOpen: boolean = false;
  isClosable: boolean = false;

  get userName(): string {
    let str = ''
    if (this.user.firstname) {
      str += this.user.firstname
    }
    if (this.user.lastname) {
      if (str.length) {
        str += ' '
      }
      str += this.user.lastname
    }
    return str;
  }

  get userInitials(): string {
    let str = ''
    if (this.user.firstname) {
      str += this.user.firstname.charAt(0)
    }
    if (this.user.lastname) {
      if (str.length) {
        str += ' '
      }
      str += this.user.lastname.charAt(0)
    }
    return str;
  }

  call(e: any): void {
    this.$emit('call', {
      userId: this.user.id
    });
  }

  editPhoto(e: any): void {
    this.$emit('editPhoto', {
      userId: this.user.id
    });
  }

  async dropdownToggle(e: any): Promise<void> {
    this.isOpen = !this.isOpen;
    await new Promise(resolve => setTimeout(resolve, 100));
    this.isClosable = this.isOpen;
  }

  onClickOutside (e: any): void {
    if(this.isClosable) {
      this.isOpen = false;
    }
  }
}
